import { attractionCategories, Attraction } from '../data/attractions';

/**
 * Get all attractions that belong to a specific neighborhood
 */
export function getAttractionsByNeighborhood(neighborhoodId: string): Attraction[] {
  return attractionCategories
    .flatMap(category => category.attractions)
    .filter(attraction => attraction.neighborhood === neighborhoodId);
}

/**
 * Get count of attractions in a neighborhood
 */
export function getNeighborhoodAttractionCount(neighborhoodId: string): number {
  return getAttractionsByNeighborhood(neighborhoodId).length;
}

/**
 * Get all unique neighborhoods from attractions
 */
export function getAllNeighborhoodIds(): string[] {
  const neighborhoods = attractionCategories
    .flatMap(category => category.attractions)
    .map(attraction => attraction.neighborhood)
    .filter((id): id is string => id !== undefined);

  return Array.from(new Set(neighborhoods));
}

/**
 * Get all attractions as a flat array
 */
export function getAllAttractions(): Attraction[] {
  return attractionCategories.flatMap(category => category.attractions);
}
